"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnstyledLink = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var UnstyledLink = exports.UnstyledLink = _styledComponents["default"].a.withConfig({
  displayName: "styles__UnstyledLink",
  componentId: "sc-1ibqv3f-0"
})(["transition:none;&,&:hover,&:active{color:inherit;}&,&:focus{text-decoration:none;}"]);
//# sourceMappingURL=styles.js.map